import { useEffect } from "react";
import { UseExploreIRAOptionsType } from "../useExploreIRAOptions";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { HenryLoadingContainer } from "../../henry-questionniare/screens/styles";
import { IconCheck, LottieAnimation } from "@manifesthhqinc/ui-library";
import Spacing from "../../../layout/spacing";
import { IRALoadingContentItem, IRALoadingContentList } from "./styles";
import { BodyLargeRegular, HeadlineMedium } from "../../../components/font";

const ExploreIRAOptionLoading = (props: UseExploreIRAOptionsType) => {
  const { setIsLoading, showResult } = props;
  useEffect(() => {
    setIsLoading(true);
    setTimeout(showResult, 5000);
  }, []);
  return (
    <TransitionWrapper>
      <HenryLoadingContainer $justifyContent="flex-start" $maxWidth="280px">
        <LottieAnimation type="henry-loading" autoplay height={136} width={136} loop />
        <Spacing vertical="11" />
        <HeadlineMedium>Just a moment...</HeadlineMedium>
        <IRALoadingContentList>
          <IRALoadingContentItem className="fade-in-item-1">
            <IconCheck />
            <BodyLargeRegular $textAlign="left">
              Identifying the best IRAs of {new Date().getFullYear()}
            </BodyLargeRegular>
          </IRALoadingContentItem>
          <IRALoadingContentItem className="fade-in-item-2">
            <IconCheck />
            <BodyLargeRegular $textAlign="left">Reviewing features</BodyLargeRegular>
          </IRALoadingContentItem>
          <IRALoadingContentItem className="fade-in-item-3">
            <IconCheck />
            <BodyLargeRegular $textAlign="left">Finding your best match</BodyLargeRegular>
          </IRALoadingContentItem>
          <IRALoadingContentItem className="fade-in-item-4">
            <IconCheck />
            <BodyLargeRegular $textAlign="left"> Calculating your IRA match score</BodyLargeRegular>
          </IRALoadingContentItem>
        </IRALoadingContentList>
      </HenryLoadingContainer>
    </TransitionWrapper>
  );
};

export default ExploreIRAOptionLoading;
